import { Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";



import { useNavigate, useParams } from "react-router-dom";
import { ISprocessoAtualizaAndamento, ProcessoAtualizaAndamento } from "../../../types/processo/ProcessoAtualizaAndamento";

import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import configUrls from "../../../config/configUrls";
import { ProcessoAtualizaAndamentoDTO } from "../../../types/processo/ProcessoAtualizaAndamentoDTO";
import errorFormat from "../../../utils/errorFormat";
import { useAddHistoricoMutation } from "../processoApiSlice";


export const ProcessoAtualizarAndamentoCreate = () => {

    const [processoAtualizaAndamento, SetProcessoAtualizaAndamento] = useState<ProcessoAtualizaAndamento>(ISprocessoAtualizaAndamento);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createHistorico, status] = useAddHistoricoMutation();
    const navigate = useNavigate();

    // Hook para seleção do processo
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum processo foi previamente selecionado");
            navigate(configUrls.PROCESSO_LIST_RT); // Usando useNavigate para navegação
        }
    }, [processoSelecionado, navigate]);


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        SetProcessoAtualizaAndamento((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        const parms: ProcessoAtualizaAndamentoDTO = {
            id: processoAtualizaAndamento.id,
            descricao: processoAtualizaAndamento.descricao,
            processoID: processoSelecionado ? processoSelecionado.id : "",
        }
        await createHistorico(parms);
    }

    useEffect(() => {



        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(-1);
            // setGrupo(ISgrupo);          

        }
    }, [status]);








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Atualizar Andamentos do processo: {processoSelecionado?.numeroProcesso}
                </Typography>
                <Box mt={2} p={2}>

                    <form onSubmit={handleSubmit} method='POST'>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        required
                                        label="Descricão:"
                                        name="descricao"
                                        onChange={handleChange}
                                        size="small"
                                        inputProps={{ maxLength: 255 }}
                                        value={processoAtualizaAndamento.descricao}
                                        multiline  // Adiciona o suporte a múltiplas linhas
                                        rows={4} />


                                    <FormHelperText>
                                        {processoAtualizaAndamento.descricao?.length}/255 caracteres
                                    </FormHelperText>
                                </FormControl>
                            </Grid>


                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Gravar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>

                    </form>



                </Box>




            </Paper>










        </>







    );










};

/*
 <GrupoTurmaForm
                    grupoTurma={grupoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/